export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref5498.cff7d3ee.jpg";